export default "__VITE_ASSET__CawRez$5__"